export default {
  login: "john-smilga",
  id: 42133389,
  node_id: "MDQ6VXNlcjQyMTMzMzg5",
  avatar_url: "https://avatars.githubusercontent.com/u/68027063?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/nmckenzie1",
  html_url: "https://github.com/nmckenzie1",
  followers_url: "https://api.github.com/users/john-smilga/followers",
  following_url:
    "https://api.github.com/users/john-smilga/following{/other_user}",
  gists_url: "https://api.github.com/users/john-smilga/gists{/gist_id}",
  starred_url:
    "https://api.github.com/users/john-smilga/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/john-smilga/subscriptions",
  organizations_url: "https://api.github.com/users/john-smilga/orgs",
  repos_url: "https://api.github.com/users/john-smilga/repos",
  events_url: "https://api.github.com/users/john-smilga/events{/privacy}",
  received_events_url:
    "https://api.github.com/users/john-smilga/received_events",
  type: "User",
  site_admin: false,
  name: "Neil McKenzie",
  company: "Freelance",
  blog: "nlmdev.web.app/",
  location: "Minneapolis",
  email: null,
  hireable: null,
  bio: "Cool coding guy",
  twitter_username: "nlm_dev",
  public_repos: 100,
  public_gists: 0,
  followers: 1000,
  following: 0,
  created_at: "2018-08-06T06:48:23Z",
  updated_at: "2020-07-08T05:01:32Z",
};
